import rdcStrings from 'features/rdc/rdcStrings.en';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageProps, StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

export interface CheckImagePreviewProps extends PressableAnalyticsProps {
  /** URI of the captured check image */
  imageProps?: ImageProps;
  /** Edit check image action handler */
  onEditPress: () => void;
}

const CheckImagePreview = ({
  imageProps,
  analyticsId,
  customAttributes,
  onEditPress,
}: CheckImagePreviewProps) => {
  const { t: translatedText } = useTranslation('rdc', {
    keyPrefix: 'reviewDeposit',
  });
  const { reviewDeposit } = rdcStrings;

  return (
    <View style={baseStyles.container}>
      <View style={baseStyles.imageContainer}>
        {imageProps ? (
          <Image
            {...imageProps}
            style={baseStyles.image}
            resizeMode="contain"
            role="img"
            accessible
          />
        ) : null}
      </View>
      <Button
        label={translatedText(
          'checkPreview.editButton',
          reviewDeposit.checkPreview.editButton,
        )}
        type="TEXT"
        size="LARGE"
        width="FULL"
        analyticsId={analyticsId}
        customAttributes={customAttributes}
        onPress={onEditPress}
      />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing.m,
    width: '100%',
  },
  image: {
    flexShrink: 1,
    flex: 1,
    maxHeight: '100%',
    maxWidth: '50%',
  },
  imageContainer: {
    alignItems: 'center',
    aspectRatio: 2.8,
    backgroundColor: theme.color.background.surface,
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing.m,
    width: '100%',
  },
});

export default CheckImagePreview;
